import React from "react";
import { useActivity } from "../hooks";
import classes from "./ActivityNullState.module.scss";
import { ActivitiesType } from "../contexts";
import exhaustiveCheck from "Utils/exhaustiveCheck";

interface ActivityNullStateProps {

}

const ActivityNullState: React.FC<ActivityNullStateProps> = () => {
   const { filter: { type } } = useActivity();

   let content: JSX.Element | null | undefined;
   switch (type) {
      case ActivitiesType.ALL:
         content = <div className={classes.content}>
            No activity found for this date range.
            <br />
            Adjust your search to see what your colleagues have been up to.
         </div>
         break;
      case ActivitiesType.MY:
         content = <div className={classes.content}>
            You didn't have any reservations for this date range.
            <br />
            Making a reservation is easy 👋👋
         </div>
         break;
      case ActivitiesType.FOLLOWING:
         content = <div className={classes.content}>
            No activity for this date range.
            <br />
            Book a space - and bring the crew.
         </div>
         break;
      default:
         content = undefined;
         exhaustiveCheck(type);
         break;
   }

   return <div className={classes.container}>
      {content}
   </div>
}

export default ActivityNullState;